
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/services",
      function () {
        return require("private-next-pages/sub/services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/services"])
      });
    }
  